import * as Highcharts from 'highcharts';
import * as HighchartsBorderRadius from 'highcharts-rounded-corners';
import * as jQuery from 'jquery';
import * as moment from 'moment';
import * as numeral from 'numeral';
import * as _ from 'underscore';

import {
	AfterContentChecked,
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnInit,
	Output,
	SimpleChanges,
	ViewChild
} from '@angular/core';

import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';

HighchartsBorderRadius(Highcharts);
@Component({
	selector: 'app-creative-r5-graph',
	styleUrls: ['./creative-r5-graph.component.css'],
	templateUrl: './creative-r5-graph.component.html'
})
export class CreativeR5GraphComponent implements OnInit, AfterContentChecked {
	@ViewChild('graphArea', { static: true }) graphElement: ElementRef;

	@Input() legendData: any;
	@Input() graphData: any;
	@Input() name: any;
	@Input() legendDisabled;
	@Input() svgWidth;
	@Input() svgHeight;
	@Input() ticksRotation;
	@Input() chartType;
	@Input() tooltipOption;
	@Input() sectiontitle;
	// tslint:disable-next-line: prefer-output-readonly
	@Output() legendSelected = new EventEmitter<any>();
	// tslint:disable-next-line: prefer-output-readonly
	@Output() mouseOverChart = new EventEmitter<any>();
	// tslint:disable-next-line: prefer-output-readonly
	@Output() mouseOutChart = new EventEmitter<any>();
	@Input() enableLabels: any;
	@Input() chartConfig;

	public selectedLegend: any;
	public oppColor = '#000';
	public bgColor = '#fff';
	public chartObj: any;
	public dateRange: string;
	public colorPalette: ColorPalette;
	public plotOptions: any;
	public isR11: boolean;

	private dataLength = 0;
	private leftExtreme = 0;
	private rightExtreme = 0;
	private stepCount: any;
	private pointsCount = 1;
	private isStackedChart = true;

	constructor(protected analyticsDataModel: AnalyticsDataModel) {}

	ngOnInit(): void {
		this.legendDisabled = this.legendDisabled === true ? true : false;
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.isR11 = this.analyticsDataModel.config.version === 'R11' ? true : false;
		if (this.graphData && this.graphData['categories']) {
			this.dataLength = this.graphData['categories'].length - 1;
		}
		this.plotOptions = {
			column: {
				borderWidth: 0,
				pointWidth: 5
			},
			series: {
				stacking: this.isStackedChart ? 'normal' : null
			}
		};
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.selectedLegend = _.findWhere(this.legendData, { selected: true });
		if (!_.isEmpty(this.graphData)) {
			this.dataLength = this.graphData.categories.length - 1;
			this.stepCount = this.graphData.stepCount ? this.graphData.stepCount : 88;
			this.drawGraph();
		}
	}

	ngAfterContentChecked(): void {
		jQuery('.legend_item').css({ color: '#2e2e2e' });
		jQuery('.item_selected').css({ color: this.colorPalette.primaryColor });
		if (this.isR11) {
			jQuery('.ovrw_badge_display p').css({ 'background-color': this.colorPalette.primaryColor });
		}
	}

	selectLegendItem(legendItem: any): void {
		this.legendSelected.emit(legendItem);
	}

	drawGraph(): void {
		this.isR11 = this.analyticsDataModel.config.version === 'R11' ? true : false;
		// tslint:disable-next-line: no-this-assignment
		const self = this;
		Highcharts.chart(
			this.graphElement.nativeElement,
			{
				chart: {
					backgroundColor: '#fff',
					height: 300,
					marginLeft: 60,
					marginRight: 60,
					type: 'column'
				},
				credits: {
					enabled: false
				},
				legend: {
					enabled: false
				},
				plotOptions: this.graphData.plotOptions
					? this.graphData.plotOptions
					: {
							column: {
								stacking: 'normal'
							},
							series: {
								borderWidth: 0,
								pointWidth: 5
							}
					  },
				series: this.graphData.columnBorders
					? this.updateBorders(this.graphData.series)
					: this.updateBordersStacked(this.graphData.series),
				title: {
					text: null
				},
				tooltip: this.tooltipOption
					? {
							backgroundColor: '#fff',
							borderRadius: this.isR11 ? 0 : 3,
							formatter(): string {
								const tooltipValue = this.y;
								let tooltipDisplay = null;
								if (self.selectedLegend.value.toLowerCase().includes('rate')) {
									tooltipDisplay = numeral(tooltipValue).format('0,0.00') + '%';
								} else {
									tooltipDisplay = tooltipValue.toLocaleString();
								}
								return `
								<p style="text-align:center">
								${self.sectiontitle} ${this.series['index'] + 1}<br>
								${self.updateTooltipName()}<br/><b>${tooltipDisplay}</b><br/>${moment(this.point.category['date'], 'MM-DD-YYYY').format(
									'M/DD/YYYY'
								)}</p>`;
								// return '<p style="text-align:center"> SEM Creative ' + (this.series.index + 1) + '<br>' + self.updateTooltipName() + '<br/><b> ' + tooltipValue + '</b><br/>'+moment(this.point.category.date, 'MM-DD-YYYY').format('M/DD/YYYY')+'</p>';
							},
							useHTML: true
					  }
					: {
							formatter(): string {
								const tooltipValue = this.y;
								let tooltipDisplay = null;
								if (self.selectedLegend.value.toLowerCase().includes('rate')) {
									tooltipDisplay = numeral(tooltipValue).format('0,0.00') + '%';
								} else {
									tooltipDisplay = tooltipValue.toLocaleString();
								}
								return `<p style="text-align:center">
									${this.series.name}
									<br/>Date: ${moment(this.key['date'], 'MM-DD-YYYY').format('MM/DD/YY')}
									<br/>
									${self.updateTooltipName()}: ${tooltipDisplay}
									</p>`;
							},
							useHTML: true
					  },
				xAxis: {
					categories: self.graphData.categories,
					gridLineColor: self.bgColor,
					labels: {
						enabled: this.enableLabels ? true : false,
						overflow: 'allow',
						formatter(): any {
							return this.value['value'];
						},
						step: 1,
						style: {
							color: this.oppColor
						}
					},
					lineColor: self.bgColor,
					lineWidth: 0,
					minorGridLineWidth: 0,
					minorTickLength: 1,
					offset: 5,
					plotLines: self.graphData.plotLines,
					tickLength: 1
				},
				yAxis: {
					gridLineColor: self.bgColor,
					labels: {
						enabled: true,
						// tslint:disable-next-line: object-literal-shorthand
						formatter: function (): any {
							if (this['value'] > 999) {
								return (Number(this['value']) / 1000).toFixed(1) + 'k';
							}
							return this['value'];
						},
						style: {
							fontSize:
								'xAxisConfig' in this.chartConfig && 'labels' in this.chartConfig.xAxisConfig
									? this.chartConfig.xAxisConfig.labels.fontSize
									: 11
						},
						x:
							'xAxisConfig' in this.chartConfig &&
							'labels' in this.chartConfig.xAxisConfig &&
							'x' in this.chartConfig.xAxisConfig.labels
								? this.chartConfig.xAxisConfig.labels.x
								: -15
					},
					lineColor: self.bgColor,
					stackLabels: {
						enabled: false,
						style: {
							fontWeight: 'bold'
						}
					},
					tickPositioner(): number[] {
						return [0, Math.ceil(this.max / 2), Math.floor(this.max)];
					},
					title: {
						text: ''
					}
				}
			},
			(chart: any) => {
				// on complete
				function noop(): void {}
				if (this.dataLength > this.stepCount) {
					this.leftExtreme = 0;
					this.rightExtreme = this.stepCount;
					chart['left_img'] = chart.renderer
						.image('../../../../../assets/images/left_arrow.png', 0, 0, 9, 14)
						.on('click', () => {
							if (this.leftExtreme > this.pointsCount) {
								this.leftExtreme -= this.pointsCount;
								this.rightExtreme -= this.pointsCount;
								chart['left_img'].show();
								chart['right_img'].show();
							} else {
								this.leftExtreme = 0;
								this.rightExtreme = this.stepCount;
								chart['left_img'].hide();
								chart['right_img'].show();
							}
							// tslint:disable-next-line: no-shadowed-variable
							let startDate = '';
							// tslint:disable-next-line: no-shadowed-variable
							let endDate = '';
							if (
								moment(self.graphData['categories'][this.leftExtreme].date, 'YYYY-MM-DD').format('MM/DD/YY') ===
								'Invalid date'
							) {
								startDate = moment(self.graphData['categories'][this.leftExtreme].date, 'MM-DD-YYYY').format(
									'M/DD/YYYY'
								);
							} else {
								startDate = moment(self.graphData['categories'][this.leftExtreme].date, 'MM-DD-YYYY').format(
									'M/DD/YYYY'
								);
							}
							if (
								moment(self.graphData['categories'][this.rightExtreme].date, 'YYYY-MM-DD').format('MM/DD/YY') ===
								'Invalid date'
							) {
								endDate = moment(self.graphData['categories'][this.rightExtreme].date, 'MM-DD-YYYY').format(
									'M/DD/YYYY'
								);
							} else {
								endDate = moment(self.graphData['categories'][this.rightExtreme].date, 'MM-DD-YYYY').format(
									'M/DD/YYYY'
								);
							}
							this.dateRange = `${startDate} - ${endDate}`;
							chart.xAxis[0].setExtremes(this.leftExtreme, this.rightExtreme);
							chart.redraw();
						})
						.css({ cursor: 'pointer' })
						.attr('x', this.isR11 ? '1.3%' : '-0.5%')
						.attr('y', '50%')
						.add();
					chart['right_img'] = chart.renderer
						.image('../../../../../assets/images/right_arrow.png', 0, 0, 9, 14)
						.on('click', () => {
							if (this.dataLength - this.rightExtreme > this.pointsCount) {
								this.leftExtreme += this.pointsCount;
								this.rightExtreme += this.pointsCount;
								chart['left_img'].show();
								chart['right_img'].show();
							} else {
								this.leftExtreme = this.dataLength - this.stepCount;
								this.rightExtreme = this.dataLength;
								chart['left_img'].show();
								chart['right_img'].hide();
							}
							// tslint:disable-next-line: no-shadowed-variable
							let startDate = '';
							// tslint:disable-next-line: no-shadowed-variable
							let endDate = '';
							if (
								moment(self.graphData['categories'][this.leftExtreme].date, 'YYYY-MM-DD').format('MM/DD/YY') ===
								'Invalid date'
							) {
								startDate = moment(self.graphData['categories'][this.leftExtreme].date, 'MM-DD-YYYY').format(
									'M/DD/YYYY'
								);
							} else {
								startDate = moment(self.graphData['categories'][this.leftExtreme].date, 'MM-DD-YYYY').format(
									'M/DD/YYYY'
								);
							}
							if (
								moment(self.graphData['categories'][this.rightExtreme].date, 'YYYY-MM-DD').format('MM/DD/YY') ===
								'Invalid date'
							) {
								endDate = moment(self.graphData['categories'][this.rightExtreme].date, 'MM-DD-YYYY').format(
									'M/DD/YYYY'
								);
							} else {
								endDate = moment(self.graphData['categories'][this.rightExtreme].date, 'MM-DD-YYYY').format(
									'M/DD/YYYY'
								);
							}
							this.dateRange = `${startDate} - ${endDate}`;
							chart.xAxis[0].setExtremes(this.leftExtreme, this.rightExtreme);
							chart.redraw();
						})
						.css({ cursor: 'pointer' })
						.attr('x', this.isR11 ? '99%' : '98%')
						.attr('y', '50%')
						.add();
					let startDate = '';
					let endDate = '';
					if (
						moment(self.graphData['categories'][this.leftExtreme].date, 'YYYY-MM-DD').format('MM/DD/YY') ===
						'Invalid date'
					) {
						startDate = moment(self.graphData['categories'][this.leftExtreme].date, 'MM-DD-YYYY').format('M/DD/YYYY');
					} else {
						startDate = moment(self.graphData['categories'][this.leftExtreme].date, 'MM-DD-YYYY').format('M/DD/YYYY');
					}
					if (
						moment(self.graphData['categories'][this.rightExtreme].date, 'YYYY-MM-DD').format('MM/DD/YY') ===
						'Invalid date'
					) {
						endDate = moment(self.graphData['categories'][this.rightExtreme].date, 'MM-DD-YYYY').format('M/DD/YYYY');
					} else {
						endDate = moment(self.graphData['categories'][this.rightExtreme].date, 'MM-DD-YYYY').format('M/DD/YYYY');
					}
					this.dateRange = `${startDate} - ${endDate}`;
					chart.xAxis[0].setExtremes(0, this.rightExtreme);
					chart['left_img'].hide();
					chart['right_img'].show();
					chart['redraw']();
					chart['right_img'].translate(-10, 0);
					chart['left_img'].translate(10, 0);
				} else {
					this.leftExtreme = 0;
					this.rightExtreme = this.dataLength;
					let startDate = '';
					let endDate = '';

					if (
						moment(self.graphData['categories'][this.leftExtreme].date, 'YYYY-MM-DD').format('MM/DD/YY') ===
						'Invalid date'
					) {
						startDate = moment(self.graphData['categories'][this.leftExtreme].date, 'MM-DD-YYYY').format('M/DD/YYYY');
					} else {
						startDate = moment(self.graphData['categories'][this.leftExtreme].date, 'MM-DD-YYYY').format('M/DD/YYYY');
					}
					if (
						moment(self.graphData['categories'][this.rightExtreme].date, 'YYYY-MM-DD').format('MM/DD/YY') ===
						'Invalid date'
					) {
						endDate = moment(self.graphData['categories'][this.rightExtreme].date, 'MM-DD-YYYY').format('M/DD/YYYY');
					} else {
						endDate = moment(self.graphData['categories'][this.rightExtreme].date, 'MM-DD-YYYY').format('M/DD/YYYY');
					}
					this.dateRange = `${startDate} - ${endDate}`;
					chart.xAxis[0].setExtremes(0, this.dataLength);
					if (chart['right_img'] && chart['left_img']) {
						chart['right_img'].hide();
						chart['left_img'].hide();
					}
				}
			}
		);
	}

	updateBordersStacked(series: any[]): any[] {
		if (series.length > 1) {
			const first = _.first(series);
			first['borderRadiusTopLeft'] = '50%';
			first['borderRadiusTopRight'] = '50%';
			const last = _.last(series);
			last['borderRadiusBottomLeft'] = '50%';
			last['borderRadiusBottomRight'] = '50%';
		} else {
			const first = _.first(series);
			first['borderRadiusTopLeft'] = '50%';
			first['borderRadiusTopRight'] = '50%';
			first['borderRadiusBottomLeft'] = '50%';
			first['borderRadiusBottomRight'] = '50%';
		}
		return series;
	}

	updateBorders(series: any[]): any[] {
		series.map((value) => {
			value['borderRadiusTopLeft'] = '50%';
			value['borderRadiusTopRight'] = '50%';
			value['borderRadiusBottomLeft'] = '50%';
			value['borderRadiusBottomRight'] = '50%';
		});
		return series;
	}

	updateTooltipName(): string {
		return this.selectedLegend.displayName;
	}
}
